export function whenReady(fn) {
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

export function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

/**
 * @param {number} number
 * @param {number} precision
 * @returns {number}
 */
export function roundTo(number, precision) {
	return parseFloat(number.toFixed(precision));
}

export async function copyToClipBoard(str) {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

export function pushToDataLayer(object) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(object);
}

export function sendEvent(name, category = null, label = null) {
  pushToDataLayer(filterNullValues({
    "event": name,
    "category": category,
    "label": label,
  }));
}

export function filterNullValues(object) {
  return Object.fromEntries(
      Object.entries(object).filter(([, value]) => value !== null)
  );
}

export function isRussianNavigatorLanguage() {
  return ["ru", "ru_RU"].includes(window.navigator.language);
}

export function getArrayDeepCopy(array) {
  return JSON.parse(JSON.stringify(array));
}

export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function getScrollbarWidth() {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.overflow = 'scroll';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  document.body.removeChild(outer);

  return scrollbarWidth;
}

export function pluralize(count, word) {
  if (count > 1) {
    return word + 's';
  }
  return word;
}

export async function downloadFile(url, name = "") {
  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(response.statusText);
    }

    const fileBlob = await response.blob();

    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(fileBlob);
    downloadLink.download = name;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  } catch (error) {
    throw new Error(error);
  }
}